import MenuItem from './PopupMenuItemLinks';

const mediaBreakPoint = '(max-width: 1024px)';
const mq = window.matchMedia(mediaBreakPoint);

class PopupMenu {
    constructor(domNode, controllerObj) {
        this.isMenubar = false;
        this.domNode = domNode;
        this.controller = controllerObj;

        this.headerEl = this.domNode.closest('header');
        this.navContainerEl = this.domNode.closest('.navigation-container');
        this.mainMenuHeight = this.headerEl.querySelector('.main').getBoundingClientRect().height;
        
        this.menuitems = []; // See PopupMenu init method
        this.firstChars = []; // See PopupMenu init method
        
        this.firstItem = null; // See PopupMenu init method
        this.lastItem = null; // See PopupMenu init method
        
        this.hasFocus = false; // See MenuItem handleFocus, handleBlur
        this.hasHover = false; // See PopupMenu handleMouseover, handleMouseout

        const msgPrefix = 'PopupMenu constructor argument domNode ';
    
        // Check whether domNode is a DOM element
        if (!domNode instanceof Element) {
            throw new TypeError(msgPrefix + 'is not a DOM Element.');
        }
        
        // Check whether domNode has child elements
        if (domNode.childElementCount === 0) {
            throw new Error(msgPrefix + 'has no element children.');
        }
        
        // Check whether domNode descendant elements have A elements
        let childElement = domNode.firstElementChild;
        while (childElement) {
            let menuitem = childElement.firstElementChild;
            if (menuitem && menuitem === 'A') {
                throw new Error(msgPrefix + 'has descendant elements that are not A elements.');
            }
            childElement = childElement.nextElementSibling;
        }
    }

    init() {
        let menuItem, textContent, numItems, megaMenuItem;
        const menuElements = this.domNode.children;
    
        // Configure the domNode itself
        if (!mq.matches) {
            this.domNode.addEventListener('mouseover', this.handleMouseover.bind(this));
            this.domNode.addEventListener('mouseout', this.handleMouseout.bind(this));
            window.addEventListener('scroll', this.handleWindowScroll.bind(this));
        }

        for(const menuElem of menuElements) {
            const menuLinkElem = menuElem.children[0];
            if (menuLinkElem && menuLinkElem.tagName === 'A') {
                menuItem = new MenuItem(menuLinkElem, this);
                menuItem.init();
                this.menuitems.push(menuItem);
                textContent = menuLinkElem.textContent.trim();
                this.firstChars.push(textContent.substring(0, 1).toLowerCase());
            }
        }
    
        // Use populated menuitems array to initialize firstItem and lastItem.
        numItems = this.menuitems.length;
        if (numItems > 0) {
            this.firstItem = this.menuitems[0];
            if (this.firstItem.domNode.classList.contains('back')) {
                this.firstItem = this.menuitems[1];
            }
            this.lastItem = this.menuitems[numItems - 1];
        }
    }
    
    /* EVENT HANDLERS */
    handleMouseover(event) {
        this.hasHover = true;
    }
    
    handleMouseout(event) {
        this.hasHover = false;
        setTimeout(this.close.bind(this, false), 1);
    }
    
    handleWindowScroll(event) {
        const newMainHeight = this.headerEl.querySelector('.main').getBoundingClientRect().height;
        if (this.mainMenuHeight !== newMainHeight) {
            this.mainMenuHeight = newMainHeight;
            const rect = this.controller.domNode.getBoundingClientRect();

            if (this.domNode.style.display === 'block') {
                this.domNode.style.top = this.domNode.parentNode.classList.contains('mega-list-item') ? this.mainMenuHeight + 'px' : rect.height + 'px';
            }
        }
    }

    /* FOCUS MANAGEMENT METHODS */
    setFocusToController(command, flag) {
        if (typeof command !== 'string') {
            command = '';
        }
    
        function setFocusToMenubarItem (controller, close) {
            while (controller) {
                if (controller.isMenubarItem) {
                    controller.domNode.focus();
                    return controller;
                } else {
                    if (close) {
                        controller.menu.close(true);
                    }
                    controller.hasFocus = false;
                }
                controller = controller.menu.controller;
            }
            return false;
        }

        if (command === '') {
            if (this.controller && this.controller.domNode) {
                this.controller.domNode.focus();
            }
            return;
        }
        
        if (!this.controller.isMenubarItem) {
            this.controller.domNode.focus();
            this.close();
        
            if (command === 'next') {
                const menubarItem = setFocusToMenubarItem(this.controller, false);
                if (menubarItem) {
                    menubarItem.menu.setFocusToNextItem(menubarItem, flag);
                }
            }
        } else {
            if (command === 'previous') {
                this.controller.menu.setFocusToPreviousItem(this.controller, flag);
            } else if (command === 'next') {
                this.controller.menu.setFocusToNextItem(this.controller, flag);
            }
        }
    }
    
    setFocusToFirstItem() {
        this.firstItem.domNode.focus();
    }
    
    setFocusToLastItem() {
        this.lastItem.domNode.focus();
    }
    
    setFocusToPreviousItem(currentItem) {
        let index;
        
        if (currentItem === this.firstItem) {
            this.lastItem.domNode.focus();
        } else {
            index = this.menuitems.indexOf(currentItem);
            this.menuitems[ index - 1 ].domNode.focus();
        }
    }
    
    setFocusToNextItem(currentItem) {
        let index;
    
        if (currentItem === this.lastItem) {
            this.firstItem.domNode.focus();
        }
        else {
            index = this.menuitems.indexOf(currentItem);
            this.menuitems[ index + 1 ].domNode.focus();
        }
    }
    
    setFocusByFirstCharacter(currentItem, char) {
        var start, index, char = char.toLowerCase();
        
        // Get start index for search based on position of currentItem
        start = this.menuitems.indexOf(currentItem) + 1;
        if (start === this.menuitems.length) {
            start = 0;
        }
        
        // Check remaining slots in the menu
        index = this.getIndexFirstChars(start, char);
        
        // If not found in remaining slots, check from beginning
        if (index === -1) {
            index = this.getIndexFirstChars(0, char);
        }
        
        // If match was found...
        if (index > -1) {
            this.menuitems[ index ].domNode.focus();
        }
    }
    
    getIndexFirstChars(startIndex, char) {
        for (var i = startIndex; i < this.firstChars.length; i++) {
            if (char === this.firstChars[ i ]) {
                return i;
            }
        }
        return -1;
    }
    
    /* MENU DISPLAY METHODS */
    
    open() {
        // Get position and bounding rectangle of controller object's DOM node
        var rect = this.controller.domNode.getBoundingClientRect();
        
        // Set CSS properties
        if (!this.controller.isMenubarItem) {
            this.domNode.parentNode.style.position = 'relative';
            this.domNode.style.display = 'block';
            this.domNode.style.position = 'absolute';
            this.domNode.style.left = rect.width + 'px';
            this.domNode.style.zIndex = 100;

            if (mq.matches) {
                this.domNode.style.position = 'fixed';
            }
        } else {
            this.domNode.style.display = 'block';
            this.domNode.style.position = 'absolute';
            this.domNode.style.top = this.domNode.parentNode.classList.contains('mega-list-item') ? this.mainMenuHeight + 'px' : rect.height + 'px';
            this.domNode.style.zIndex = 100;

            if (mq.matches) {
                this.domNode.style.position = 'fixed';
                this.domNode.style.top = '0';
                this.headerEl.querySelector('.getintouch-container').style.zIndex = -1;
                this.navContainerEl.style.zIndex = 12;
            }
        }
        
        this.controller.setExpanded(true);
    }
    
    close(force) {
        var controllerHasHover = this.controller.hasHover;
        var hasFocus = this.hasFocus;
        
        for (var i = 0; i < this.menuitems.length; i++) {
            var mi = this.menuitems[i];
        }
            
        for (const mi of this.menuitems) {
            if (mi.popupMenu) {
                hasFocus = hasFocus | mi.popupMenu.hasFocus;
            }
        }
        
        if (!this.controller.isMenubarItem) {
            controllerHasHover = false;
        }

        if (force || (!hasFocus && !this.hasHover && !controllerHasHover)) {
            this.domNode.style.display = 'none';
            this.domNode.style.zIndex = 0;
            this.controller.setExpanded(false);

            if (mq.matches) {
                this.headerEl.querySelector('.getintouch-container').style.zIndex = 'auto';
                this.navContainerEl.style.zIndex = 1;
            }
        }
    }
}

export default PopupMenu;